import { render, staticRenderFns } from "./NewCarsInStockCard.vue?vue&type=template&id=703b3d36&scoped=true"
import script from "./NewCarsInStockCard.vue?vue&type=script&lang=js"
export * from "./NewCarsInStockCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703b3d36",
  null
  
)

export default component.exports